import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArtistProductsService, ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-product-details-dialog',
    templateUrl: './product-details-dialog.component.html',
    standalone: false
})
export class ProductDetailsDialogComponent implements OnInit {
    @Input() showProductDialog: boolean = false;
    @Input() productId: string | null = null;
    @Output() onClose = new EventEmitter<void>();
    @Output() showProductDialogChange = new EventEmitter<boolean>();

    public selectedProduct: ArtistProductSummary | null = null;

    constructor(
        private artistProductsService: ArtistProductsService,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit(): void {

        if (this.productId) {
            this.loadProductDetails(this.productId);
        }
    }

    private loadProductDetails(productId: string): void {
        this.spinner.show();
        this.artistProductsService.getProductDetail(productId).subscribe({
            next: (product: ArtistProductSummary) => {
                this.selectedProduct = product;
                this.spinner.hide();
            },
            error: (error) => {
                console.error('Error loading product details:', error);
                this.spinner.hide();
            }
        });
    }

    public closeDialog() {
        this.showProductDialogChange.emit(false);
        this.onClose.emit();
    }
}